import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IAddCollectionChallengeRequest } from './add-collection-challenge-request';
import type { IAddCollectionChallengeResponse } from './add-collection-challenge-response';
import { addCollectionChallengeResponseSchema } from './add-collection-challenge-response';

export async function addCollectionChallengeApi({
  collectionId,
  ...body
}: IAddCollectionChallengeRequest): Promise<IValidatedResponse<IAddCollectionChallengeResponse>> {
  return postRequest<IAddCollectionChallengeResponse>({
    path: `/sys/collections/${collectionId}/challenges`,
    body,
    schema: addCollectionChallengeResponseSchema,
  });
}
